<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap v-if="currentUserRoleID<=2">
                <v-flex sm12 lg12>
                    <v-layout row wrap>
                        <v-flex sm12 lg12>

                            <!-- v-card  -->
                            <v-card class="mb-4">
                                <v-expansion-panel v-model="expandedModel" expand>
                                    <v-expansion-panel-content class="teal">
                                        <div slot="header" >
                                            <span class="white--text">
                                                All SMS Lists
                                                <strong class="black--text ml-2">

                                                </strong>
                                            </span>
                                        </div>
                                        <v-divider></v-divider>

                                        <v-card-text class="white">
                                            <v-flex xs12 sm12 md12 mt-3>
                                                <v-data-table
                                                  :headers="maillist.headers"
                                                  :items="items"
                                                  hide-actions
                                                  class="elevation-1"
                                                >
                                                    <template
                                                        slot="items" slot-scope="props"
                                                    >
                                                        <tr>
                                                            <td>{{ (props.index + 1)+((current_page_id-1)*per_page) }}</td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.commzgate_msg_id }}</span></td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.sender.full_name }}</span></td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.receiver.full_name }}</span></td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.receiver_number }}</span></td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.message }}</span></td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.created_at.date }}</span></td>
                                                            <!-- <td class="text-xs-left"><span class="">{{ getActivatedName(props.item.activated) }}</span></td> -->
                                                            <td>
                                                                <v-layout row wrap>
                                                                    <v-flex xs4 pa-2>
                                                                        <v-btn
                                                                            fab outline small color="success"
                                                                            v-on:click="openViewDialogAction(props.item)"
                                                                        >
                                                                            <v-icon>visibility</v-icon>
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </td>
                                                            <td>
                                                                <v-layout row wrap>
                                                                    <v-flex xs4 pa-2>
                                                                        <v-btn
                                                                            fab outline small color="red"
                                                                            v-on:click="openDeleteDialogAction(props.item)"
                                                                        >
                                                                            <v-icon>delete</v-icon>
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                                <v-flex mt-5>
                                                    <app-vue-pagination :collection.sync="collection"></app-vue-pagination>
                                                </v-flex>
                                            </v-flex>
                                        </v-card-text>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-card>

                        </v-flex>
                    </v-layout>

                    <!-- dialog modal  -->

                    <!-- view dialog -->
                    <v-layout row justify-center>
                        <v-dialog
                            v-model="openViewDialog" width="600px">
                            <v-card>
                                <v-card-title class="success">
                                    <span class="title white--text">
                                        SMS Details For {{ selectedObj.commzgate_msg_id }}
                                    </span>
                                </v-card-title>
                                <v-card-text>
                                    <!-- mail owner name -->
                                    <v-layout row wrap mt-3 mb-3>
                                        <v-flex xs4 sm4 md4 lg4>
                                            <span>
                                                Commzgate Message ID:
                                            </span>
                                        </v-flex>
                                        <v-flex xs8 sm8 md8 lg8>
                                            <span>
                                                {{ selectedObj.commzgate_msg_id }}
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <!-- Sender Name -->
                                    <v-layout row wrap mt-3 mb-3>
                                        <v-flex xs4 sm4 md4 lg4>
                                            <span>
                                                Sender Name:
                                            </span>
                                        </v-flex>
                                        <v-flex xs8 sm8 md8 lg8>
                                            <span>
                                                {{ selectedObj.sender.full_name }}
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <!-- Receiver Name -->
                                    <v-layout row wrap mt-3 mb-3>
                                        <v-flex xs4 sm4 md4 lg4>
                                            <span>
                                                Receiver Name:
                                            </span>
                                        </v-flex>
                                        <v-flex xs8 sm8 md8 lg8>
                                            <span>
                                                {{ selectedObj.receiver.full_name }}
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <!-- Receiver Contact Number -->
                                    <v-layout row wrap mt-3 mb-3>
                                        <v-flex xs4 sm4 md4 lg4>
                                            <span>
                                                Receiver Contact No.:
                                            </span>
                                        </v-flex>
                                        <v-flex xs8 sm8 md8 lg8>
                                            <span>
                                                {{ selectedObj.receiver_number }}
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <!-- Message -->
                                    <v-layout row wrap mt-3 mb-3>
                                        <v-flex xs4 sm4 md4 lg4>
                                            <span>
                                                Message:
                                            </span>
                                        </v-flex>
                                        <v-flex xs8 sm8 md8 lg8>
                                            <span v-html="selectedObj.message">
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <!-- Message -->
                                    <v-layout row wrap mt-3 mb-3>
                                        <v-flex xs4 sm4 md4 lg4>
                                            <span>
                                                Created At:
                                            </span>
                                        </v-flex>
                                        <v-flex xs8 sm8 md8 lg8>
                                            <span v-html="selectedObj.created_at.date">
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>

                                </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="success darken-1" flat="flat" @click="openViewDialog = false">Close</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                    </v-layout>

                    <!-- delete dialog -->
                    <v-layout row justify-center>
                        <v-dialog v-model="openDeleteDialog" persistent max-width="550">

                            <v-card>
                                <v-card-title class="title red white--text">Confirm Delete SMS - {{ selectedObj.commzgate_msg_id }} ?</v-card-title>
                                <v-card-text>
                                    Please make sure you know what you are doing as this action is undone.
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="grey darken-1" flat @click="openDeleteDialog = false">Cancel</v-btn>
                                    <v-btn color="red darken-1" flat @click="deleteResourceAction(selectedObj.id)">Delete</v-btn>
                                </v-card-actions>
                         </v-card>
                       </v-dialog>
                     </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import {
        // eslint-disable-next-line
        ACTION_SMS_GET_ALL_SMS_SERVICES,
        // eslint-disable-next-line
        GETTERS_SMS_GET_ALL_SMS_SERVICES,
        // eslint-disable-next-line
        ACTION_SMS_DELETE_SMS_TO_STATION_MASTER_SERVICE,
    } from '../../../../../../utils/constants/modules/Sms/AllSmsModules'

    import {
        GETTERS_USER_GROUPS_GET_AUTH_USER
    } from '../../../../../../utils/constants/modules/UserGroups/Users/UserModules';

    import { PaginationCollections } from '../../../../../../utils/mixins';

    import VuePagination from '../../../../../../components/paginations/VuePagination.vue';

    export default {
        mixins: [
            PaginationCollections
        ],
        props:{
        },
        created: function () {
            let userRoleID = window.localStorage.getItem('current_user_role');

            this.currentUserRoleID = userRoleID

            let payload = {
                per_page: this.per_page_num,
                page_id: 1
            }

            this.$store.dispatch(ACTION_SMS_GET_ALL_SMS_SERVICES, payload)
        },
        data: function () {
            return {
                feature_img: require("../../../../../../assets/images/features/default.png"),
                per_page_num: 20,
                search: null,
                urrentUserRoleID: null,
                expandedModel: [true],
                maillist: {
                    headers: [
                        {
                            text: 'No',
                            align: 'left',
                            sortable: false,
                        },
                        { text: 'Commzgate ID', value: 'sender_id', sortable: false, },
                        { text: 'Sender Name', value: 'sender.full_name',sortable: false, },
                        { text: 'Receiver Name', value: 'receiver.full_name',sortable: false, },
                        { text: 'Receiver Number', value: 'receiver.full_name',sortable: false, },
                        { text: 'Message', value: 'message' ,sortable: false, },
                        { text: 'Created At', value: 'created_at' ,sortable: false, },
                        //{ text: 'Activated', value: 'activated' ,sortable: false, },
                        { text: 'View', value: '' ,sortable: false, },
                        { text: 'Delete', value: '' ,sortable: false, },
                    ],
                },
                // LIST DATA TABLE
                openViewDialog: false,
                openAddDialog: false,
                openEditDialog: false,
                openDeleteDialog: false,
                selectedObj: {
                    sender_id: null,
                    sender: {
                        full_name: null,
                    },
                    receiver_id: null,
                    receiver: {
                        full_name: null,
                    },
                    sender_number: null,
                    receiver_number: null,
                    message: null,
                    commzgate_msg_id: null,
                    created_at: {
                        date: null,
                    },
                    updated_at: {
                        date: null,
                    },
                },
            };
        },
        computed: {
            pagination_collections () {
                return this.$store.getters.GETTER_PAGINATION_GET_LISTS
            },
            current_page_id () {
                return this.collection.currentPage
            },
            per_page () {
                return this.collection.perPage
            },
            items() {
                let vm = this
                let result = this.$store.getters.GETTERS_SMS_GET_ALL_SMS_SERVICES
                var array = Object.keys(result).map(item => result[item]);

                return array
            },
            currentAuthUser() {
                let authUser = this.$store.getters.GETTERS_USER_GROUPS_GET_AUTH_USER

                return authUser
            },
        },
        watch: {
            pagination_collections: function(value) {
                let defaultCollection = {
                    action: ACTION_SMS_GET_ALL_SMS_SERVICES,
                    sort: 'desc',
                    order_by: 'id',
                    per_page: value['meta']['per_page'],
                    current_page: value['meta']['current_page'],
                    last_page: value['meta']['last_page'],
                    total: value['meta']['total'],
                    from: value['meta']['from'],
                    to: value['meta']['to'],
                    data: value['data'],
                    payload: {
                        per_page: this.per_page,
                        page_id: this.current_page_id,
                    }
                }

                this.collection.setState(defaultCollection)
            },
        },
        methods: {

            openViewDialogAction: function (item) {
                this.openViewDialog = true

                this.selectedObj = item
            },
            openAddDialogAction: function () {
                this.openAddDialog = true
            },
            openEditDialogAction: function (item) {
                this.openEditDialog = true

                this.selectedObj = item
            },
            openDeleteDialogAction: function (item) {
                this.openDeleteDialog = true

                this.selectedObj = item
            },

            deleteResourceAction: function (id) {
                let payload = {
                    sms_id: id,
                }
                this.$store.dispatch(ACTION_SMS_DELETE_SMS_TO_STATION_MASTER_SERVICE, payload)
                this.openDeleteDialog = false
            },
        },
        components: {
            appVuePagination: VuePagination,
        }
    }
</script>

<style lang="css" scoped>
</style>
